export type DialogTranslations = {
  content: {
    button: {
      cancel: string;
      confirm: string;
    };
    title: {
      warning: string;
    };
  };
};

export const dialogTranslations: DialogTranslations = {
  content: {
    button: {
      cancel: 'Cancel',
      confirm: 'Confirm',
    },
    title: {
      warning: 'Warning',
    },
  },
};
